// 全局配置
export default {
  BASE_URL: process.env.VUE_APP_BASE_URL,
  HOST_IMG: process.env.VUE_APP_IMG_HOST,
  HOST_API: process.env.VUE_APP_API_HOST,
  BASE_API_PREFIX: process.env.VUE_APP_BASE_API_PREFIX,
  OP_API_PREFIX:process.env.VUE_APP_OP_API_PREFIX,
  RECHARGE_API_PREFIX: process.env.VUE_APP_RECHARGE_API_PREFIX,
  RECHARGE_OP_API_PREFIX:process.env.VUE_APP_RECHARGE_OP_API_PREFIX
  // HOST_API: '',
};
